"use strict";
angular.module("PrintixPageHeader", [])

  .constant("PrintixPageHeaderTemplate", "app/shared-components/page-header/page-header.html")

  .directive("pageHeader", ["PrintixPageHeaderTemplate", function(PrintixPageHeaderTemplate) {
    return {
      restrict: 'E',
      templateUrl: PrintixPageHeaderTemplate,
      scope: {
        headerText: "=",
        headerSecondaryText: "=",
        headerSecondaryTextLink: "=?",
        pxTest: "=",
        headerClass: "=",
        clickFunction: "&?"
      },
      link: function($scope, elem, attrs) {
        $scope.showLink = ($scope.clickFunction) ? true : false;
      }
    };
  }]);